export const AnalyticsEvents = {
  // Acquisition & Auth
  LANDING_CTA_CLICK: 'landing_cta_click',
  LANDING_DEMO_CLICK: 'landing_demo_click',
  LANDING_DEMO_PLAY: 'landing_demo_play',
  LANDING_DEMO_CLOSE: 'landing_demo_close',
  LANDING_DEMO_COMPLETE: 'landing_demo_complete',
  SIGNUP_START: 'signup_start',
  SIGNUP_COMPLETE: 'signup_complete',
  LOGIN: 'login',
  LOGIN_FAILED: 'login_failed',
  PASSWORD_RESET_REQUEST: 'password_reset_request',
  PASSWORD_RESET_COMPLETE: 'password_reset_complete',
  LOGOUT: 'logout',

  // Onboarding
  TOUR_START: 'tour_start',
  TOUR_STEP_VIEW: 'tour_step_view',
  TOUR_COMPLETE: 'tour_complete',
  TOUR_SKIP: 'tour_skip',
  // LT-314 — first-run checklist + empty-state CTAs.
  ONBOARDING_CHECKLIST_VIEWED: 'onboarding.checklist.viewed',
  ONBOARDING_CHECKLIST_TASK_COMPLETED: 'onboarding.checklist.task_completed',
  ONBOARDING_CHECKLIST_DISMISSED: 'onboarding.checklist.dismissed',
  EMPTY_STATE_CTA_CLICKED: 'empty_state.cta_clicked',
  // LT-315 — pre-flight side-sheet before sequence activation.
  SEQUENCE_PREFLIGHT_VIEWED: 'sequence.preflight.viewed',
  SEQUENCE_PREFLIGHT_ACTIVATED: 'sequence.preflight.activated',
  SEQUENCE_PREFLIGHT_CANCELLED: 'sequence.preflight.cancelled',

  // Campaign Creation (wizard)
  CAMPAIGN_WIZARD_STEP_VIEW: 'campaign_wizard_step_view',
  CAMPAIGN_WIZARD_STEP_COMPLETE: 'campaign_wizard_step_complete',
  CAMPAIGN_WIZARD_BACK: 'campaign_wizard_back',
  CAMPAIGN_WIZARD_ABANDON: 'campaign_wizard_abandon',
  CAMPAIGN_PRESET_AGENT_USED: 'campaign_preset_agent_used',
  CAMPAIGN_SAVED_AGENT_USED: 'campaign_saved_agent_used',
  CAMPAIGN_TEST_CALL: 'campaign_test_call',
  CAMPAIGN_SAVE_PROMPT: 'campaign_save_prompt',
  CAMPAIGN_LEADS_UPLOAD: 'campaign_leads_upload',
  CAMPAIGN_LEADS_VALIDATION_EXPORT: 'campaign_leads_validation_export',
  CAMPAIGN_TEMPLATE_DOWNLOAD: 'campaign_template_download',
  CAMPAIGN_CREATED: 'campaign_created',

  // Run Execution
  RUN_STARTED: 'run_started',
  RUN_STOPPED: 'run_stopped',
  RUN_LEAD_RETRY: 'run_lead_retry',
  RUN_LEAD_CUT: 'run_lead_cut',
  RUN_EXPORT_SUMMARIES: 'run_export_call_summaries',
  RUN_VIEWED: 'run_viewed',

  // Leads
  LEAD_ADD: 'lead_add',
  LEAD_UPDATE: 'lead_update',
  LEAD_IMPORT_CSV: 'lead_import_csv',
  LEAD_DELETE: 'lead_delete',
  LEAD_BULK_DELETE: 'lead_bulk_delete',

  // Create Agent
  AGENT_SAVE: 'agent_save',
  AGENT_UPDATE: 'agent_update',
  AGENT_DELETE: 'agent_delete',
  AGENT_PRESET_SELECT: 'agent_preset_select',
  AGENT_TEST_CALL: 'agent_test_call',

  // Subscription & Payments
  SUBSCRIPTION_CHECKOUT_STARTED: 'subscription_checkout_started',
  SUBSCRIPTION_PLAN_CHANGE: 'subscription_plan_change',
  CREDIT_CHECKOUT_STARTED: 'credit_checkout_started',
  CUSTOMER_PORTAL_OPENED: 'customer_portal_opened',
  PAYMENT_SUCCESS: 'payment_success',
  PENDING_DOWNGRADE_CANCEL: 'pending_downgrade_cancel',

  // Credits
  CREDITS_PAGE_VIEW: 'credits_page_view',
  CREDITS_BALANCE_REFRESH: 'credits_balance_refresh',
  CREDITS_PURCHASE_CLICK: 'credits_purchase_click',

  // Inbound
  INBOUND_CONFIG_SAVED: 'inbound_config_saved',
  INBOUND_CONFIG_DELETED: 'inbound_config_deleted',
  INBOUND_CONFIG_PAGE_VIEW: 'inbound_config_page_view',

  // Feedback & Support
  FEEDBACK_SUBMITTED: 'feedback_submitted',
  FEEDBACK_UPDATED: 'feedback_updated',
  FEEDBACK_DELETED: 'feedback_deleted',
  SUPPORT_TICKET_CREATED: 'support_ticket_created',

  // Settings
  SETTINGS_PROFILE_SAVED: 'settings_profile_saved',
  SETTINGS_AGENT_SAVED: 'settings_agent_saved',
  SETTINGS_DEFAULT_ASSISTANT_SAVED: 'settings_default_assistant_saved',
  // LT-379: user picked a default Agent on Settings → Calling.
  SETTINGS_DEFAULT_AGENT_SAVED: 'settings_default_agent_saved',

  // Engagement
  NOTIFICATION_READ: 'notification_read',
  NOTIFICATION_READ_ALL: 'notification_read_all',
  DASHBOARD_RUN_CLICK: 'dashboard_run_click',
  QUICK_ACTION_CLICK: 'quick_action_click',

  // Legal
  TERMS_PAGE_VIEW: 'terms_page_view',
  PRIVACY_PAGE_VIEW: 'privacy_page_view',

  // Optional: Errors
  FORM_VALIDATION_ERROR: 'form_validation_error',
  API_ERROR_CRITICAL: 'api_error_critical',
  CREDITS_EXHAUSTED_BLOCK: 'credits_exhausted_block',
} as const;

export type AnalyticsEventName = typeof AnalyticsEvents[keyof typeof AnalyticsEvents];
